import Heading from '@/components/atoms/Heading';
import * as S from './styles';
import Badge from '@/components/atoms/Badge';
import Banner from '@/components/atoms/Banner';
import Text from '@/components/atoms/Text';
import { useTheme } from 'styled-components';
import { Produto as ProdutoType } from '@/types/produto';
import { Combo } from '@/types/combo';

export type ProdutoInfoProps = {
  $produto: ProdutoType | Combo;
};

export default function ProdutoInfoMobile(props: ProdutoInfoProps) {
  const {
    $produto: { imagem, imagemMobile, nome, descricao, etiqueta },
  } = props;
  const theme = useTheme();
  return (
    <S.Container>
      <S.ProdutoInfoTextos>
        <Heading
          $priority={1}
          $size={6}
          $color="neutral"
          $weight="bold"
          $align="left"
          $highContrast={true}
          $text={nome ?? descricao}
        />
        {etiqueta ? (
          <S.ProdutoTags>
            <Badge
              $size={1}
              $rounded={false}
              $variant="solid"
              $color={etiqueta.corFundo}
              $highContrast={true}
              $text={etiqueta.descricao}
              $textColor={etiqueta.corTexto}
            />
          </S.ProdutoTags>
        ) : null}
      </S.ProdutoInfoTextos>
      <S.ProdutoImagem>
        <Banner
          descricaoImagem={nome ?? descricao}
          priority={true}
          imagemUrl={imagemMobile ?? imagem}
          style={{
            borderRadius: theme.spacing['4'],
            objectFit: 'cover',
          }}
        />
      </S.ProdutoImagem>
      <S.ProdutoInfoTextos>
        <Heading
          $priority={2}
          $size={4}
          $color="neutral"
          $weight="bold"
          $align="left"
          $highContrast={true}
          $text="Descrição"
        />
        <Text
          $size={2}
          $color="neutral"
          $weight="medium"
          $align="left"
          $highContrast={false}
          $text={descricao ?? ''}
        />
      </S.ProdutoInfoTextos>
    </S.Container>
  );
}
